import React from 'react';
import { AlertCircle, CheckCircle2, Clock, Users, Circle } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * MissionFilterChips - Barre de filtres décisionnels pour missions
 */
const MissionFilterChips = ({ activeFilter, onFilterChange, counts = {} }) => {
  
  const filters = [
    {
      id: 'to_staff',
      label: 'À staffer',
      icon: AlertCircle,
      color: 'blue',
      count: counts.to_staff || 0
    },
    {
      id: 'with_matches',
      label: 'Avec matchs',
      icon: Users,
      color: 'green',
      count: counts.with_matches || 0
    },
    {
      id: 'active',
      label: 'En cours',
      icon: CheckCircle2,
      color: 'purple',
      count: counts.active || 0
    },
    {
      id: 'urgent',
      label: 'Urgentes',
      icon: Clock,
      color: 'red',
      count: counts.urgent || 0
    },
    {
      id: 'all',
      label: 'Toutes',
      icon: Circle,
      color: 'gray',
      count: counts.all || 0
    }
  ];

  const getActiveStyles = (filter) => {
    if (activeFilter !== filter.id) {
      return 'bg-white border-gray-200 text-gray-600 hover:bg-gray-50';
    }
    
    switch (filter.color) {
      case 'blue':
        return 'bg-blue-500 border-blue-500 text-white';
      case 'green':
        return 'bg-green-500 border-green-500 text-white';
      case 'purple':
        return 'bg-purple-500 border-purple-500 text-white';
      case 'red':
        return 'bg-red-500 border-red-500 text-white';
      default:
        return 'bg-gray-700 border-gray-700 text-white';
    }
  };

  const getIconColor = (filter) => {
    if (activeFilter === filter.id) return 'text-white';
    
    switch (filter.color) {
      case 'blue': return 'text-blue-500';
      case 'green': return 'text-green-500';
      case 'purple': return 'text-purple-500';
      case 'red': return 'text-red-500';
      default: return 'text-gray-500';
    }
  };

  return (
    <div 
      className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide"
      data-testid="mission-filter-chips"
    >
      {filters.map((filter) => (
        <button
          key={filter.id}
          onClick={() => onFilterChange(activeFilter === filter.id ? 'all' : filter.id)}
          className={cn(
            "flex items-center gap-1.5 px-3 py-2 rounded-full border text-sm font-medium whitespace-nowrap transition-all",
            getActiveStyles(filter)
          )}
          data-testid={`mission-filter-${filter.id}`}
        >
          <filter.icon className={cn("h-4 w-4", getIconColor(filter))} />
          {filter.label}
          {filter.count > 0 && (
            <span className={cn(
              "ml-1 px-1.5 py-0.5 rounded-full text-xs font-bold",
              activeFilter === filter.id 
                ? "bg-white/20 text-white" 
                : "bg-gray-100 text-gray-600"
            )}>
              {filter.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default MissionFilterChips;
